import { html, LitElement } from 'lit';
import { DebugService } from '../../../../shared/services/debug.service.js';
import { links } from '../../../../shared/styles/links.style.js';
import { style } from './lender-review.style.js';
import { pageHeaders } from '../../../../shared/styles/page-headers.style.js';
import { currencyFormatter } from '../../../../shared/formatters/currency.formatter.js';
import { REFI_LIENHOLDER_CONST } from '../../../../shared/constants/app.constants.js';

class RefiLenderReview extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiLenderReview');
    this.apiErrorMessage = '';
    this.loading = false;
    this.lenderInfo = {};
    this.missingAccountNumber = false;
    this.missingLenderName = false;
    this.lenderInfoDisplay = {};
  }

  static get properties() {
    return {
      apiErrorMessage: { type: String },
      loading: { type: Boolean },
      lenderInfo: { type: Object },
      lenderInfoPrefilled: { type: Boolean },
    };
  }

  static get styles() {
    return [pageHeaders, links, style];
  }

  render() {
    this.debug.log('rendered lienholder-review');
    if (!this.lenderInfo.lienHolderName) {
      this.lenderInfoDisplay.lienHolderName = 'Enter lender name';
      this.missingLenderName = true;
    } else {
      this.lenderInfoDisplay.lienHolderName = this.lenderInfo.lienHolderName;
      this.missingLenderName = false;
    }
    if (!this.lenderInfo.lienHolderAccountNumber) {
      this.lenderInfoDisplay.lienHolderAccountNumber = 'Enter account number';
      this.missingAccountNumber = true;
    } else {
      this.lenderInfoDisplay.lienHolderAccountNumber = REFI_LIENHOLDER_CONST.HASHTAG + this.lenderInfo.lienHolderAccountNumber;
      this.missingAccountNumber = false;
    }
    this.lenderInfoDisplay.currentLoanPayOffAmount = this.lenderInfo.currentLoanPayOffAmount;

    return this.lenderInfoDisplay.currentLoanPayOffAmount
      ? html` <div class="lienholder_review__contents">
          <fs-body-text id="lienholderNameText" variant="${this.missingLenderName ? 'disabled' : 'primary'}" style="font-style: ${this.missingLenderName ? 'italic' : 'normal'}"> ${this.lenderInfoDisplay.lienHolderName} </fs-body-text>
          <fs-body-text id="lienholderAccountNumberText" variant="${this.missingAccountNumber ? 'disabled' : 'primary'}" style="font-style: ${this.missingAccountNumber ? 'italic' : 'normal'}"
            >${this.lenderInfoDisplay.lienHolderAccountNumber}</fs-body-text
          >
          <fs-body-text variant="primary">${currencyFormatter(this.lenderInfoDisplay.currentLoanPayOffAmount)}</fs-body-text>
        </div>`
      : '';
  }
}

customElements.define('refi-lender-review', RefiLenderReview);
